/* eslint-disable no-console */
import type { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { catchError, throwError } from 'rxjs';

import { IS_SERVER_TOKEN } from '@app/shared/utils';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  readonly #isServer = inject<boolean>(IS_SERVER_TOKEN);

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (this.#isServer) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const safeStringify = (obj: unknown): string => {
          try {
            return JSON.stringify(obj, null, 2);
          } catch {
            return String(obj);
          }
        };
        // Просто логируем - Sentry сам подхватит через ErrorHandler
        console.error('HTTP Error:', {
          url: error.url || req.url,
          status: error.status,
          statusText: error.statusText,
          responseBody: safeStringify(error.error),
          requestBody: safeStringify(req.body),
        });

        return throwError(() => error);
      }),
    );
  }
}
